
let currentProduct;
let initializing = false;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const initializeMazing = async () => {
    await mazing({
        customerName: 'exclusivefurniture',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container{
                  padding: 16px;
                  width: 100%;
                  position: absolute;
                  bottom: 16px;
                  left: 0;
                  transform: none;
                  display: flex;
                  justify-content: flex-end;
                  pointer-events: none;
                  z-index: 5;
                  opacity: 0;
                  margin-bottom: 0;
                  transition: opacity 0.35s ease, transform 0.35s ease;
                }
                
                .mazing-button-container.is-visible{
                  opacity: 1;
                  transform: translateY(0);
                  pointer-events: auto;
                }
                
                .mazing-threed-btn,
                .mazing-ar-btn{
                  pointer-events: auto;
                  position: relative;
                  right: auto;
                  bottom: auto;
                
                  display: inline-flex;
                  align-items: center;
                  gap: 10px;
                
                  padding: 12px 16px;
                  border-radius: 9999px;
                
                  background: rgba(255,255,255,0.92) !important;
                  color: #111 !important;
                
                  border: 1px solid rgba(0,0,0,0.08);
                  box-shadow: 0 10px 24px rgba(0,0,0,0.12) !important;
                
                  backdrop-filter: blur(8px);
                  -webkit-backdrop-filter: blur(8px);
                
                  transition: transform .15s ease, box-shadow .15s ease, background .15s ease;
                }
                
                .mazing-threed-btn-text,
                .mazing-ar-btn-text{
                  font-weight: 600;
                  color: #111;
                }
                
                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon{
                  filter: none;
                  opacity: 0.9;
                  margin-right: 0;
                }

                .mazing-threed-btn:hover,
                .mazing-ar-btn:hover{
                  transform: translateY(-1px);
                  box-shadow: 0 14px 30px rgba(0,0,0,0.16) !important;
                  background: rgba(255,255,255,0.98) !important;
                }

                .mazing-threed-btn::before,
                .mazing-ar-btn::before{
                  content: none;
                }

                @media (max-width: 500px){
                  .mazing-button-container{
                    bottom: 0;
                    justify-content: flex-end;
                  }
                
                  .mazing-threed-btn-text,
                  .mazing-ar-btn-text{
                    display: none !important;
                  }
                
                  .mazing-threed-btn,
                  .mazing-ar-btn{
                    padding: 10px;
                    height: 52px;
                    width: 52px;
                    border-radius: 9999px;
                    justify-content: center;
                  }
                
                  .mazing-ar-btn-icon,
                  .mazing-threed-btn-icon{
                    height: 22px;
                    margin-right: 0;
                  }
                }

            `,
            placementSelector: '.product__media-gallery',
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in Room",
                        "de": "Im Raum anzeigen",
                        "fr": "Voir dans votre espace",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');
};

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');

    currentProduct = `${productParts[0]}`;
    let finalSKU = currentProduct.toLowerCase();

    const selectedInput = document.querySelector('input[type="radio"][name^="product-form"]:checked');
    if (selectedInput) {
        const label = selectedInput.closest('label');
        const variantText = label ? label.textContent.trim() : '';
        const cleanedText = variantText.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        finalSKU += cleanedText;
    }

    console.log('Final SKU:', finalSKU);
    return finalSKU;
};

const initializeScript = async () => {
    if (initializing) return;
    initializing = true;

    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
        document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

        await initializeMazing();

        // avoid flickering by init with opacity 0 and smooth fade in 500ms after init
        setTimeout(() => {
            document
                .querySelectorAll('.mazing-button-container')
                .forEach(el => el.classList.add('is-visible'));
        }, 500);

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    } finally {
        initializing = false;
    }
};

initializeScript();
